<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? tooltip : ''"><i class="fa fa-upload"></i>{{ Text ? " " + Text : "" }}</b-button>
</template>

<script>

export default ({
  name: "button-upload",

  props: {
    variant: {
      type: String,
      default: 'secondary'
    },
    tooltip: {
      type: String,
      default: 'Отправить'
    },
    Text: {
      type: String,
      default: null
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips
    }
  }
})
</script>
